import { createIcon } from './createIcon';

/** Two offset sheets — copy this message to the clipboard. */
export const CopyIcon = createIcon({
  name: 'CopyIcon',
  viewBox: '0 0 24 24',
  size: 12,
  svgProps: {
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
  children: (
    <>
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </>
  ),
});

export default CopyIcon;
